'use strict';

/**
 * Webduct Resources Helper
 *
 * @author Erik Orozco <eorozco@intersog.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Deitric Jang <djang@buildcentrix.com>
 * @author Luis Hernandez <lhernandez@intersog.com>
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @author Monika Gole <monika.gole@ncircletech.com>
 *
 * @copyright (c) 2018-2024 Build Centrix
 */
var WebductResources = function () {

    // Helper
    var helper = {};

    // Settings
    var baseUrl = 'MissingBaseUrl';
    var baseApiUrl = 'MissingBaseApiUrl';
    var apiUrls = {};
    var constants = {};
    var deploymentToken = 'MissingDeploymentToken';
    var hashbang = '#!';
    var classicHost = 'host';
    var permissions = {};

    /************************************** Deprecated Functionality **************************************************/

    /**
     * Get Edit Cart Item Url
     *
     * @since 1.0.0
     * @deprecated Use `getCartEditItemUrl`
     * @param {String} index
     * @return {String}
     */
    helper.getEditCartItemUrl = function (index) {
        return helper.getCartEditItemUrl(index);
    };

    /**
     * Get Edit Product Link
     *
     * @since 1.0.0
     * @deprecated Use `getOrderingEditProductUrl`
     * @param {String} index
     * @param {String} type
     * @return {String}
     */
    helper.getEditProductUrl = function (index, type) {
        return helper.getOrderingEditProductUrl(index, type);
    };

    /**
     * Get The Active Job Orders URL
     *
     * @since 1.0.0
     * @deprecated Use `getCartUrl`
     * @return {String}
     */
    helper.getActiveJobOrdersUrl = function () {

        return helper.getCartUrl();

    };

    /**
     * Get Default Webduct Image URL
     *
     * @deprecated Use `getDefaultImageUrl`
     * @since 1.0.0
     * @returns {String}
     */
    helper.getDefaultWebductImageUrl = function () {
        return helper.getDefaultImageUrl();
    };

    /**
     * Get the Header Logo via the deployment token
     *
     * @since 1.0.0
     * @deprecated Use `getHeaderLogoUrl`
     * @return {String}
     */
    helper.getHeaderLogo = function () {
        return helper.getHeaderLogoUrl();
    };

    /**
     * Get Ordering Url
     *
     * @since 2.51.0
     * @return {String} url
     */
    helper.getOrderingUrl = function() {

        var result;

        // If user can view Ordering UI
        if (permissions.canViewProducts()) {

            // Return Ordering Base Url
            result = baseUrl + '/ordering-ui/';

        }

        return result;

    };

    /**
     * Get a Product API URL
     *
     * @since 1.0.0
     * @deprecated Use `getOrderingApiProductUrl` Instead
     * @return {String}
     */
    helper.getOrderingViewProductUrl = function(productId) {
        return helper.getOrderingApiProductUrl(productId);
    };

    /**
     * Get a Product Display URL
     *
     * @since 1.0.0
     * @deprecated Use `getOrderingProductDisplayUrl` Instead
     * @param {String} id
     * @param {String} categoryUid
     * @return {String}
     */
    helper.getProductDisplayUrl = function(id, categoryUid) {
        return helper.getOrderingProductDisplayUrl(id, categoryUid)
    };

    /************************************** External Functionality ****************************************************/

    /**
     * Get Activity Report Url
     *
     * @since 2.37.0
     * @returns {String}
     */
    helper.getActivityReportUrl = function () {
        var result;
        if (permissions.canViewActivityReportUI()) {
            result = baseUrl + '/manufacturing-admin-ui/reports/activity/list';
        }
        return result;
    };

    /**
     * Get an API Url
     *
     * @since 1.1.0
     * @param {String} apiId The ID of the API URL to fetch (from apiUrls)
     */
    helper.getApiUrl = function (apiId) {
        var result;
        if (apiUrls.hasOwnProperty(apiId)) {
            result = apiUrls[apiId];
        }
        return result;
    };

    /**
     * Get Application Settings Admin URL
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getApplicationSettingsAdminUrl = function () {
        var result;
        if (permissions.canViewApplicationSettingsAdminUI()) {
            result = baseUrl + '/manufacturing-admin-ui/settings/application/list';
        }
        return result;
    };

    /**
     * Get Assemblies URL
     *
     * @since 2.22.0
     * @returns {String}
     */
    helper.getAssembliesUrl = function () {
        var result;
        if (permissions.canViewAssembliesUI()) {
            result = baseUrl + '/assembly-ui';
        }
        return result;
    };

    /**
     * Get Spooling UI URL
     *
     * @since 3.5.0
     * @returns {String}
     */
    helper.getSpoolingUIUrl = function () {
        var result;
        if (permissions.canViewAssembliesUI()) {
            result = baseUrl + '/spooling-ui';
        }
        return result;
    };

    /**
     * Get the URL for viewing, ordering, or managing central products.
     * @deprecated Use getProductUrl instead
     *
     * @since 2.45.0
     * @returns {String}
     */
    helper.getCentralProductsUrl = function () {
        var result;
        result = baseUrl + '/product-ui';
        return result;
    };

    /**
     * Get Assembly view URL
     *
     * @since 2.25.0
     * @returns {String}
     */
    helper.getAssemblyViewUrl = function (assemblyId) {
        var result;
        result = baseUrl + '/assembly-ui/assemblies/view/' + assemblyId;
        return result;
    };

    /**
     * Get Buildcentrix Company Website
     * @since 2.54.0
     */
    helper.getBcxCompanyWebsiteUrl = function() {
        return 'https://buildcentrix.com/';
    };

    /**
     * Get Buildcentrix Facebook Social Url
     * @since 2.54.0
     */
    helper.getBcxFacebookUrl = function() {
        return 'https://www.facebook.com/buildcentrix';
    };

    /**
     * Get Buildcentrix Instagram Social Url
     * @since 2.54.0
     */
    helper.getBcxInstagramUrl = function() {
        return 'https://www.instagram.com/buildcentrix/';
    };

    /**
     * Get Buildcentrix LinkedIn Social Url
     * @since 2.54.0
     */
    helper.getBcxLinkedInUrl = function() {
        return 'https://www.linkedin.com/company/buildcentrix/';
    };

    /**
     * Get Buildcentrix Support Url
     * @since 2.56.0
     */
    helper.getBcxSupportUrl = function() {
        return 'https://buildcentrix.com/contact-3/';
    };

    /**
     * Get Buildcentrix Twitter Social Url
     * @since 2.54.0
     */
    helper.getBcxTwitterUrl = function() {
        return 'https://twitter.com/buildcentrix';
    };

    /**
     * Get Buildcentrix YouTube Social Url
     * @since 2.54.0
     */
    helper.getBcxYouTubeUrl = function() {
        return 'https://www.youtube.com/@buildcentrixcustomersuppor1095';
    };

    /**
     * Get Billing Detail Report Url
     *
     * @deprecated To standardize naming conventions. Use "getInventoryBillingDetailReportUrl"
     * @since 1.28.0
     * @param {?String} userId
     * @return {String}
     */
    helper.getBillingDetailReportUrl = function (userId) {

        var result;
        if (permissions.canViewInventoryBillingDetailReportUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/reports/billingSummary';

            if (userId) {
                result += '?userId=' + userId;
            }
        }
        return result;

    };

    /**
     * Get Calendar Url
     *
     * @since 1.0.0
     * @param {String} type
     * @returns {String}
     */
    helper.getCalendarUrl = function(type) {

        var result;

        if (permissions.canViewCalendarUI()) {
            result = baseUrl + '/calendar-ui-v2/' + hashbang + '/';

            if ((type && type === 'production') &&
                permissions.canViewProductionCalendarUI()) {
                result += 'calendars/' + type;
            } else if ((type && type === 'delivery') &&
                permissions.canViewShippingCalendarUI()) {
                result += 'calendars/' + type;
            }
        }

        return result

    };

    /**
     * Get Cart Url
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getCartUrl = function () {

        return baseUrl + '/ordering-ui/' + hashbang + '/main/cart';

    };

    /**
     * Get Cart Edit Item Url
     *
     * @since 1.0.0
     * @param {String} cartIndex
     * @returns {String}
     */
    helper.getCartEditItemUrl = function (cartIndex) {

        var result;
        result = buildClassicUrlPrefix(baseUrl, deploymentToken) + '/index.php?module=order&action=editCartItemModern&itemID=' + cartIndex;
        return result;

    };

    /**
     * Get the categories listing URL
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getCategoriesUrl = function() {

        var result;
        result = baseUrl + '/ordering-ui/' + hashbang + '/main/categories';
        return result;

    };

    /**
     * Get Classic Add Fitting URL
     *
     * @since 3.11.0
     * @return {String}
     */
    helper.getClassicAddFittingUrl = function () {
        return buildClassicUrlPrefix(baseUrl, deploymentToken) + '/index.php?module=order&action=addFitting';
    };

    /**
     * Get Classic API URL
     *
     * @since 1.0.0
     * @param {String} action
     * @return {String}
     */
    helper.getClassicApiUrl = function(action) {

        var result;
        result = buildClassicUrlPrefix(baseUrl, deploymentToken) + '/index.php?ajax=true&action=' + action;
        return result;

    };

    /**
     * Get Classic Submit Order URL
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getClassicSubmitOrderApiUrl = function() {

        var result;
        result = helper.getClassicApiUrl('submitOrder');
        return result;

    };

    /**
     * Get Crews Admin URL
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getCrewsAdminUrl = function () {
        var result;
        if (permissions.canViewCrewsAdminUI()) {
            result = baseUrl + '/organization-ui/crews/list';
        }
        return result;
    };

    /**
     * Get Crews List URL
     *
     * @deprecated To standardize naming conventions. Use "getCrewsAdminUrl"
     * @since 2.5.0
     * @returns {String}
     */
    helper.getCrewsListUrl = function () {
        var result;
        if (permissions.canViewCrewsAdminUI()) {
            result = baseUrl + '/organization-ui/crews/list';
        }
        return result;
    };

    /**
     * Get Crews Manager URL
     *
     * @since 2.5.0
     * @param {String=} id (Optional)
     * @returns {String}
     */
    helper.getCrewsManagerUrl = function (id) {
        var result;
        if (permissions.canViewCrewsAdminUI()) {
            result = baseUrl + '/organization-ui/crews/manage' + id ? ('/' + id) : '';
        }
        return result;
    };

    /**
     * Get the Dashboard Url
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getDashboardUrl = function () {

        var result;
        if (permissions.canViewDashboardUI()) {
            result = baseUrl + '/dashboard-ui-v2/dashboard';
        }
        return result;

    };

    /**
     * Get Default Image Url
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getDefaultImageUrl = function () {

        var result;
        result = baseUrl + '/webduct/assets/deployments/shared/images/' + 'OtherItemsIcon.png';
        return result;

    };

    /**
     * Get Delivery Calendar URL
     *
     * @deprecated To standardize naming conventions. Use "getShippingCalendarUrl" instead
     * @since 1.0.0
     * @returns {String}
     */
    helper.getDeliveryCalendarUrl = function () {
        return helper.getCalendarUrl('delivery');
    };

    /**
     * Get Environments URL
     *
     * @since 2.21.0
     * @returns {String}
     */
    helper.getEnvironmentsUrl = function () {
        return baseUrl + '/organization-ui/environments/list';
    };

    /**
     * Get The Shop Timecards Admin URL
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getFieldTimeCardsAdminUrl = function () {

        var result;
        if (permissions.canViewFieldTimecardAdmin() && constants.isModernFieldTimecardUI()) { // Modern Interface
            result = baseUrl + '/timecard-ui/' + hashbang + '/dashboard/admin';
        }
        return result;

    };

    /**
     * Get The Field Timecards Select User URL
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getFieldTimeCardsSelectUserUrl = function () {

        var result;
        if (permissions.canViewFieldTimecardWorkstation() && constants.isModernFieldTimecardUI()) {
            result = baseUrl + '/timecard-ui/' + hashbang + '/select/user';
        }
        return result;

    };

    /**
     * Get The Field Timecards URL
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getFieldTimecardsUrl = function () {

        var result;

        if (permissions.canViewFieldTimecardAdmin()) { // Timecard Admin Menu Page
            result = helper.getFieldTimeCardsAdminUrl();
        } else if (permissions.canViewFieldTimecardWorkstation()) { // Timecard Workstation Select User Page
            result = helper.getFieldTimeCardsSelectUserUrl();
        }

        return result;


    };

    /**
     * Get Fittings Url
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getFittingsUrl = function () {

        return baseUrl + '/ordering-ui/' + hashbang + '/main/categories';

    };

    /**
     * Get Fulfillment Csv Export Url
     * @todo Remove? getCombinedCsvUrl was removed in LIBENV-206 and is no longer available
     *
     * @since 1.0.0
     * @params {String} index
     * @params {String} fulfillmentGroupIndex
     * @returns {String}
     */
    // helper.getFulfillmentCsvExportUrl = function (orderIndex, fulfillmentGroupIndex) {
    //
    //     var result;
    //     if (permissions.canViewFulfillmentCsvExport()) {
    //         result = getCombinedCsvUrl(orderIndex, fulfillmentGroupIndex);
    //     }
    //     return result;
    //
    // };

    /**
     * Get Header Logo Url
     *
     * Note: logos are being migrated to S3/CloudFront (from wd-library-style-guide)
     *
     * @since 2.13.0
     * @returns {String}
     */
    helper.getHeaderLogoUrl = function () {

        var result;

        // Get the URL of the CDN (i.e. CloudFront) root
        var cdnBaseUrl = constants.getCdnBaseUrl();

        // If the WD_CDN_BASE_URL application_vars is found use the CloudFront URL
        if (cdnBaseUrl) {
            result = cdnBaseUrl + '/' + deploymentToken + '/logos/logo.png';
        } else {    // If logo is not migrated to CloudFront yet, fallback to use style guide logo URL
            result = baseUrl + '/resources/wd-library-style-guide/images/deployments/' + deploymentToken + '/logos/logo.png';
        }

        return result;

    };

    /**
     * Get Home Url
     *
     * @deprecated To standardize naming conventions. Use "getDashboardUrl"
     * @since 1.0.0
     * @returns {String}
     */
    helper.getHomeUrl = function () {
        return helper.getDashboardUrl();
    };

    /**
     * Get Internal Add Inventory Types URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalAddInventoryTypesUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/inventory/type/add/';
    };

    /**
     * Get Internal Add Simple Product URL
     *
     * @since 3.11.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalAddSimpleProductUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/product/create/simple';
    };

    /**
     * Get Internal Add Product with Attributes URL
     *
     * @since 3.11.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalAddProductWithAttributesUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/product/create/with-attributes';
    };

    /**
     * Get Internal Calendar URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalCalendarURL = function (hashbang, calendarType) {
        return getHashBang(hashbang) + '/main/calendar/' + (calendarType ? calendarType : '');
    };

    /**
     * Get Internal Cart URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalCartUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/cart';
    };

    /**
     * Get Internal Category URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalCategoryUrl = function (hashbang, categoryId, parameters) {
        return getHashBang(hashbang) + '/main/order/' + (categoryId ? categoryId : '') + (parameters ? parameters : '');
    };

    /**
     * Get Internal Categories URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalCategoriesUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/categories/';
    };

    /**
     * Get Internal Edit Inventory Types URL
     *
     * @param {Boolean} hashbang
     * @param {String} inventoryTypeId
     * @returns {String}
     */
    helper.getInternalEditInventoryTypesUrl = function (hashbang, inventoryTypeId) {
        return getHashBang(hashbang) + '/main/inventory/type/edit' + (inventoryTypeId ? '/' + inventoryTypeId : '');
    };

    /**
     * Get Internal Fitting Shop Labour Factors URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalFittingShopLabourFactorsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/fittings/factors/labour/shop';
    };

    /**
     * Get Internal Fitting Shop Labour Factor Categories URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalFittingShopLabourFactorCategoriesUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/fittings/factors/labour/shop/categories';
    };

    /**
     * Get Internal Cart URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalHomeUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/home';
    };

    /**
     * Get Internal Insulations URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalInsulationsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/insulations';
    };

    /**
     * Get Internal Insulations Cost / Weight Factors URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalInsulationsCostWeightFactorsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/insulations/factors/costweight';
    };

    /**
     * Get Internal Insulations Cost / Weight Factor Categories URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalInsulationsCostWeightFactorCategoriesUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/insulations/factors/costweight/categories';
    };

    /**
     * Get Internal Insulations Shop Labour Factors URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalInsulationsShopLabourFactorsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/insulations/factors/labour/shop';
    };

    /**
     * Get Internal Inventory Types URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @param {String} subcategoryId
     * @returns {String}
     */
    helper.getInternalInventoryTypesUrl = function (hashbang, subcategoryId) {
        return getHashBang(hashbang) + '/main/inventoryTypes' + (subcategoryId ? '/' + subcategoryId : '');
    };

    /**
     * Get Internal Job Budget URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalJobBudgetUrl = function (hashbang, jobId) {
        return getHashBang(hashbang) + '/jobs/metrics/budget' + (jobId ? '/' + jobId : '');
    };

    /**
     * Get Internal Job Codes URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalJobCodesUrl = function (hashbang, codeType) {
        return getHashBang(hashbang) + '/jobs/codes' + (codeType ? '/' + codeType : '');
    };

    /**
     * Get Internal Job Phases URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @param {String} jobId
     * @return {String}
     */
    helper.getInternalJobPhasesUrl = function (hashbang, jobId) {
        return getHashBang(hashbang) + '/jobs/' + jobId + '/phases';
    };

    /**
     * Get Internal Job Phase Codes URL
     *
     * @since 1.23.0
     * @param {Boolean} hashbang
     * @param {String} jobIndex
     * @param {String} phaseId
     * @return {String}
     */
    helper.getInternalJobPhaseCodesUrl = function (hashbang, jobIndex, phaseId) {
        return getHashBang(hashbang) + '/jobs/' + jobIndex + '/phases/' + phaseId;
    };

    /**
     * Get Internal Jobs URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalJobsUrl = function (hashbang, jobId) {
        return getHashBang(hashbang) + '/jobs' + (jobId ? '/' + jobId : '');
    };

    /**
     * Get Internal List Inventory URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalListInventoryUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/inventory/list';
    };

    /**
     * Get Internal Locations URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalLocationsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/locations/';
    };

    /**
     * Get Internal Lookahead Orders URL
     *
     * @since 2.42.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalLookaheadOrdersUrl = function (hashbang) {
        var result;
        result = getHashBang(hashbang) + '/main/orders/list/lookahead';
        return result;
    };

    /**
     * Get Internal Manage Inventory URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @param {String} inventoryId
     * @returns {String}
     */
    helper.getInternalManageInventoryUrl = function (hashbang, inventoryId) {
        return getHashBang(hashbang) + '/main/inventory/manage/' + (inventoryId ? inventoryId : '');
    };

    /**
     * Get Internal Materials URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalMaterialsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/materials';
    };

    /**
     * Get Internal Catalogs URL
     *
     * @since 1.25.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalCatalogsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/catalogs';
    };

     /**
     * Get Internal Order Fulfillment Groups URL
     *
     * @since 1.26.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalOrderFulfillmentGroupsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/orders/fulfillment/groups';
    };

    /**
     * Get Internal Material Cost / Weight Factors URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalMaterialCostWeightFactorsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/materials/factors/costweight';
    };

    /**
     * Get Internal Material Cost / Weight Factor Categories URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalMaterialCostWeightFactorCategoriesUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/materials/factors/costweight/categories';
    };

    /**
     * Get Internal Material Gauge Lookups URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalMaterialGaugeLookupsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/materials/lookups/gauges';
    };

    /**
     * Get Internal Order Complete URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalOrderCompleteUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/orderComplete';
    };

    /**
     * Get V2 Internal Order Complete URL
     * - this is mainly used for the ordering-ui breadcrumbs
     *
     * @since 3.13.0
     * @returns {String}
     */
    helper.getInternalOrderCompleteV2Url = function (hashbang) {
        return getHashBang(hashbang) + '/main/order-complete';
    };

    /**
     * Get Internal Orders URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @param {String?} type
     * @returns {String}
     */
    helper.getInternalOrdersUrl = function (hashbang, type) {
        return getHashBang(hashbang) + '/main/orders' + (type ? '/' + type : '');
    };

    /**
     * Get Internal Order Details URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @param {String} orderIndex
     * @returns {String}
     */
    helper.getInternalOrderDetailsUrl = function (hashbang, orderIndex) {
        return getHashBang(hashbang) + '/main/workOrder' + (orderIndex ? '/' + orderIndex : '');
    };

    /**
     * Get Internal Order Requests URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @param {String?} orderId
     * @returns {String}
     */
    helper.getInternalOrderRequestsUrl = function (hashbang, orderId) {
        return getHashBang(hashbang) + '/main/orders/requests' + (orderId ? '/' + orderId : '');
    };

    /**
     * Get Internal Pricing URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalPricingUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/pricing';
    };

    /**
     * Get Internal Product URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalProductUrl = function (hashbang, productId, parameters) {
        return getHashBang(hashbang) + '/main/product' + (productId ? '/' + productId : '') + (parameters ? parameters : '');
    };

    /**
     * Get Internal Report: Billing Summary URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportBillingSummaryUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports/billingSummary';
    };

    /**
     * Get Internal Report: Inventory Levels URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportInventoryLevelsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports/inventoryLevels';
    };

    /**
     * Get Internal Report: Inventory Value URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportInventoryValueUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports/inventoryValue';
    };

    /**
     * Get Internal Report: Inventory Status URL
     *
     * @since 1.22.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportInventoryStatusUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports/inventoryStatus';
    };

    /**
     * Get Internal Report: Job Billing URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportJobBillingUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports/jobBilling';
    };

    /**
     * Get Internal Report: Missing Inventory URL
     *
     * @since 1.0.0
     * @deprecated Use getInternalReportInventoryStatusUrl Instead
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportMissingInventoryUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports/missingInventory';
    };

    /**
     * Get Internal Report: Rental Summary URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportRentalSummaryUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports/rentalSummary';
    };

    /**
     * Get Internal Report: Retired Inventory URL
     *
     * @since 1.0.0
     * @deprecated Use getInternalReportInventoryStatusUrl Instead
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportRetiredInventoryUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports/retiredInventory';
    };

    /**
     * Get Internal Reports URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReportsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/reports';
    };

    /**
     * Get Internal Returns URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalReturnsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/returns';
    };

    /**
     * Get Internal Saved Orders URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalSavedOrdersUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/loadOrders';
    };

    /**
     * Get Internal Specifications URL
     *
     * @since 1.0.0
     * @param hashbang
     * @returns {String}
     */
    helper.getInternalSpecificationsUrl = function (hashbang) {
        return getHashBang(hashbang) + '/hvac/specifications';
    };

    /**
     * Get Internal Subcategory Types URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @param {String} type
     * @returns {String}
     */
    helper.getInternalSubcategoryTypesUrl = function (hashbang, type) {
        return getHashBang(hashbang) + '/main/inventory/types' + (type ? '/' + type : '');
    };

    /**
     * Get Internal Subcategories URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @param {String} subcategoryUId
     * @returns {String}
     */
    helper.getInternalSubcategoriesUrl = function (hashbang, subcategoryUId) {
        return getHashBang(hashbang) + '/main/subcategories' + (subcategoryUId ? '/' + subcategoryUId : '');
    };

    /**
     * Get Internal Submit Order URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getInternalSubmitOrderUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/submitOrder';
    };

    /**
     * Get V2 Internal Submit Order URL
     * - this is mainly used for the ordering-ui breadcrumbs
     *
     * @since 3.13.0
     * @returns {String}
     */
    helper.getInternalSubmitOrderV2Url = function (hashbang) {
        return getHashBang(hashbang) + '/main/submit-order';
    };

    /**
     * Get Work Orders (orders listing) URL
     *
     * @since 1.0.0
     * @param {Boolean} hashbang
     * @returns {String}
     */
    helper.getInternalWorkOrdersUrl = function (hashbang) {
        return getHashBang(hashbang) + '/main/orders/list/work';
    };

    /**
     * Get Inventory Admin Url
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getInventoryAdminUrl = function () {

        var result;
        if (permissions.canViewInventoryAdminUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/inventory/list';
        }
        return result;

    };

    /**
     * Get Inventory Billing Detail Report Url
     *
     * @since 2.54.0
     * @param {String=} userId
     * @return {String}
     */
    helper.getInventoryBillingDetailReportUrl = function (userId) {

        var result;
        if (permissions.canViewInventoryBillingDetailReportUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/reports/billingSummary';
            if (userId) {
                result += '?userId=' + userId;
            }
        }
        return result;

    };

    /**
     * Get Inventory Job Billing Details Report Url
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getInventoryJobBillingSummaryReportUrl = function () {

        var result;
        if (permissions.canViewInventoryJobBillingSummaryReportUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/reports/jobBilling';
        }
        return result;

    };

    /**
     * Get Inventory Orders Url
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getInventoryOrdersUrl = function () {

        var result;
        if (permissions.canViewInventoryOrdersUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/orders';
        }
        return result;

    };

    /**
     * Get Inventory Reports Menu Url
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getInventoryReportsMenuUrl = function () {

        var result;
        if (permissions.canViewInventoryReportsMenuUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/reports';
        }
        return result;

    };

    /**
     * Get Job Admin Url
     *
     * @returns {String}
     */
    helper.getJobAdminUrl = function () {

        return permissions.canViewJobsAdminUI()
            ? baseUrl + '/job-center-ui/jobs/list'
            : null;

    };

    /**
     * Get Job Codes Admin Url
     *
     * @returns {String}
     */
    helper.getJobCodesAdminUrl = function () {

        return permissions.canViewJobCodesAdminUI()
            ? baseUrl + '/job-center-ui/jobs/codes/list'
            : null;

    };

    /**
     * Get Job Center Url
     *
     * @returns {String}
     */
    helper.getJobCenterUrl = function () {
        return helper.getJobAdminUrl();
    };

    /**
     * Get List CAM Export Item Files Url
     *
     * @since 2.30.0
     * @return {String}
     */
    helper.getListCamExportItemFilesUrl = function () {
        var result;
        if (permissions.canViewCamExportItemFiles()) {
            result = baseUrl + '/manufacturing-admin-ui/exports/cams/camduct/itemfiles/list';
        }
        return result;
    };

    /**
     * Get List CAM Export Mappings Url
     *
     * @since 2.29.0
     * @return {String}
     */
    helper.getListCamExportMappingsUrl = function () {
        var result;
        if (permissions.canViewCamExportMappings()) {
            result = baseUrl + '/manufacturing-admin-ui/exports/cams/mappings/list';
        }
        return result;
    };

    /**
     * Get List CAM Export Software Versions Url
     *
     * @since 2.30.0
     * @return {String}
     */
    helper.getListCamExportSoftwareVersionsUrl = function () {
        var result;
        if (permissions.canViewCamExportSoftwareVersions()) {
            result = baseUrl + '/manufacturing-admin-ui/exports/cams/defaults/manage';
        }
        return result;
    };

    /**
     * Get List Joints Url
     *
     * @since 2.24.0
     * @return {String}
     */
    helper.getListJointsUrl = function () {
        var result;
        if (permissions.canViewJoints()) {
            result = baseUrl + '/manufacturing-admin-ui/hvac/joints/list';
        }
        return result;
    };

    /**
     * Get the LogoutUrl
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getLogoutUrl = function () {

        var result;
        result = buildClassicUrlPrefix(baseUrl, deploymentToken) + '/index.php?module=order&action=logout';
        return result;

    };

    /**
     * Get Lookahead Orders listing URL
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getLookaheadOrdersUrl = function () {

        var result;
        if (permissions.canViewLookaheadOrdersUI()) {
            result = baseUrl + '/order-admin-ui/orders/list/lookahead';
        }
        return result;

    };

    /**
     * Get Manage CAM Export Item Files Url
     *
     * @since 2.30.0
     * @param {String} hashbang
     * @param {String} id
     * @return {String}
     */
    helper.getManageCamExportItemFilesUrl = function (hashbang, id) {
        var result;
        if (permissions.canManageCamExportItemFiles()) {
            result = baseUrl + '/manufacturing-admin-ui/exports/cams/camduct/itemfiles/manage/' + id;
        }
        return result;
    };

    /**
     * Get Manage CAM Export Mappings Url
     *
     * @since 2.29.0
     * @param {String} hashbang
     * @param {String} id
     * @param {String} type
     * @return {String}
     */
    helper.getManageCamExportMappingsUrl = function (hashbang, id, type) {
        var result;
        if (permissions.canManageCamExportMappings()) {
            result = baseUrl + '/manufacturing-admin-ui/exports/cams/mappings/manage/' + type + '/' + id;
        }
        return result;
    };

    /**
     * Get Manage CAM Export Scripts Url
     *
     * @since 2.32.0
     * @param {String} hashbang
     * @param {String} id
     * @return {String}
     */
    helper.getManageCamExportScriptsUrl = function (hashbang, id) {
        var result;
        if (permissions.canManageCamExportScripts()) {
            result = baseUrl + '/manufacturing-admin-ui/exports/cams/scripts/manage/' + id;
        }
        return result;
    };

    /**
     * Get Manage CAM Export Software Versions Url
     *
     * @since 2.30.0
     * @param {String} hashbang
     * @param {String} id
     * @return {String}
     */
    helper.getManageCamExportSoftwareVersionsUrl = function (hashbang, id) {
        var result;
        if (permissions.canManageCamExportSoftwareVersions()) {
            result = baseUrl + '/manufacturing-admin-ui/exports/cams/defaults/manage/' + id;
        }
        return result;
    };

    /**
     * Get Manage Joints Url
     *
     * @since 2.24.0
     * @param {String?} hashbang
     * @param {String?} id
     * @return {String}
     */
    helper.getManageJointsUrl = function (hashbang, id) {
        var result;
        if (permissions.canManageJoints()) {
            result = baseUrl + '/manufacturing-admin-ui/hvac/joints/manage' + id ? '/' + id : '';
        }
        return result;
    };

    /**
     * Get Manufacturing Admin Url
     *
     * @since 2.28.0
     * @return {String}
     */
    helper.getManufacturingAdminUrl = function () {
        var result;
        if (permissions.canViewManufacturingAdminUI()) {
            result = baseUrl + '/manufacturing-admin-ui/';
        }
        return result;
    };

    /**
     * Get Manage Category URL
     *
     * @since 1.24.0
     * @param {Boolean} hashbang
     * @param {String} categoryId
     * @returns {String}
     */
    helper.getManageCategoryUrl = function(hashbang, categoryId) {
        return getHashBang(hashbang) + '/main/category/manage/' + (categoryId ? categoryId : '');
    };

    /**
     * Get Internal Edit Product URL
     *
     * @since 2.16.0
     * @param {String} productIndex
     * @param {String} productType
     * @returns {String|null}
     */
    helper.getInternalEditProductUrl = function (productIndex, productType) {
        if (['simple', 'stock_only'].includes(productType)) {
           return '/main/product/manage/' + productIndex;
        }

        return null;
    };

    /**
     * Get URL to for ordering Piping & Plumbing products
     *
     * @param {String} plumbingUrlOverride
     * @return {String}
     */
    helper.getPipingPlumbingUrl = function (plumbingUrlOverride) {
        var result;
        if (plumbingUrlOverride && permissions.canViewOrderingUI()) {
            // Use the specified URL for Piping & Plumbing products
            result = plumbingUrlOverride;
        } else {
            // The default behaviour is to use the product-ui URL for Piping & Plumbing
            result = helper.getProductUrl();
        }
        return result;
    };

    /**
     *  Get URL to edit the Library/Deployment Export Scripts.
     *
     * @since 2.42.1
     * @param {String} productId
     * @return {String}
     */
    helper.getProductExportScriptsUrl = function(productId){
        return baseUrl + '/manufacturing-admin-ui/exports/cams/scripts/manage/' + productId;
    };

    /**
     * Get V2 Internal Order Complete URL
     *
     * @since 3.13.0
     * @returns {String}
     */
    helper.getOrderCompleteUrl = function () {
        return baseUrl + '/ordering-ui/' + hashbang + '/main/order-complete';
    };

    /**
     * Get Order Model Viewer URL
     *
     * @since 2.36.0
     * @param {String} orderIndex
     * @returns {String}
     */
    helper.getOrderModelViewerUrl = function (orderIndex) {
        return baseUrl + '/order-admin-ui/modelViewer/view/' + orderIndex;
    };

    /**
     * Get Ordering Edit Product URL
     *
     * @since 1.0.0
     * @param {String} productIndex
     * @param {String} productType
     * @returns {String}
     */
    helper.getOrderingEditProductUrl = function (productIndex, productType) {
        var result;
        if (['simple', 'stock_only'].includes(productType)) {
            var orderingUiPath = 'ordering-ui';

            result = baseUrl + '/' + orderingUiPath + '/' + hashbang + helper.getInternalEditProductUrl(productIndex, productType);

        } else if (productType === 'fitting') {
            result = buildClassicUrlPrefix(baseUrl, deploymentToken) + '/index.php?module=order&action=editProduct&id=' + productIndex;
        }
        return result;
    };

    /**
     * Get Ordering Product Display Url
     *
     * @since 1.0.0
     * @param {String} id
     * @param {String} categoryUid
     * @returns {String}
     */
    helper.getOrderingProductDisplayUrl = function (id, categoryUid) {

        var result;
        categoryUid = categoryUid || '';

        result = baseUrl + '/ordering-ui/' + hashbang + '/main/product/' + id;
        result += categoryUid !== '' ? '?categoryUid=' + categoryUid : '';
        result += '#top';

        return result;

    };

    /**
     * Get Ordering Central Product Display Url
     *
     * @since 2.41.0
     * @param {String} id
     * @returns {String}
     */
    helper.getOrderingCentralProductDisplayUrl = function (id) {

        var result;

        result = baseUrl + '/ordering-ui/' + hashbang + '/main/product/';
        result += '?centralProductId=' + id;
        result += '#top';

        return result;

    };

    /**
     * Get Ordering API Product Url
     *
     * @since 1.0.0
     * @param {String} productIndex
     * @returns {String}
     */
    helper.getOrderingApiProductUrl = function (productIndex) {

        var result;
        result = baseApiUrl + '/products/' + productIndex;
        return result;

    };

    /**
     * Get Organizations Admin URL
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getOrganizationAdminUrl = function () {
        var result;
        if (permissions.canViewOrganizationsAdminUI()) {
            result = baseUrl + '/organization-ui/organizations/list';
        }
        return result;
    };

    /**
     * Get Price Adjustment Admin URL
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getPriceAdjustmentAdminUrl = function () {
        var result;
        if (permissions.canViewPriceAdjustmentsAdminUI()) {
            result = baseUrl + '/organization-ui/adjustments/pricing/list';
        }
        return result;
    };

    /**
     * Get Privacy Policy URL
     *
     * @since 1.1.4
     * @return {String}
     */
    helper.getPrivacyPolicyUrl = function() {
        return 'https://buildcentrix.com/privacy-policy/';
    };

    /**
     * Get Production Calendar URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getProductionCalendarUrl = function () {
        var result;

        if (permissions.canViewProductionCalendarUI()) {
            result = helper.getCalendarUrl('production');
        }

        return result;
    };

    /**
     * Get Product URL
     *
     * @since 2.35.0
     * @returns {String}
     */
    helper.getProductUrl = function () {
        var result;

        if (permissions.canViewProductUI()) {
            result = baseUrl + '/product-ui/';
        }

        return result;
    };

    /**
     * Get Reimbursement URL
     *
     * @since 1.13.0
     * @returns {String}
     */
    helper.getReimbursementsUrl = function () {

        var result;

        if (permissions.canViewReimbursementsUI()) {
            result = baseUrl + '/reimbursement-ui/';
        }

        return result;

    };

    /**
     * Get Reimbursement Entries Report URL
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getReimbursementEntriesReportUrl = function () {

        var result;

        if (permissions.canViewReimbursementEntriesReportUI()) {
            result = baseUrl + '/reimbursement-ui/reporting';
        }

        return result;

    };

    /**
     * Get The Saved Job Orders URL
     *
     * @deprecated To standardize naming conventions. Use "getSavedWorkOrdersUrl"
     * @since 1.0.0
     * @return {String}
     */
    helper.getSavedJobOrdersUrl = function () {

        return baseUrl + '/ordering-ui/' + hashbang + '/main/loadOrders';

    };

    /**
     * Get Saved Work Orders URL
     *
     * @since 2.54.0
     * @return {String}
     */
    helper.getSavedWorkOrdersUrl = function () {
        var result;
        if (permissions.canViewSavedWorkOrdersUI()) {
            result = baseUrl + '/ordering-ui/' + hashbang + '/main/loadOrders';
        }
        return result;
    };

    /**
     * Get Shipping Calendar URL
     *
     * @since 2.51.0
     * @returns {String}
     */
    helper.getShippingCalendarUrl = function () {
        var result;
        if (permissions.canViewShippingCalendarUI()) {
            result = helper.getCalendarUrl('delivery');
        }
        return result;
    };

    /**
     * Get the Job Code Admin Link
     *
     * @deprecated Unused function
     * @return {String}
     */
    // helper.getShopJobCodeAdminUrl = function () {
    //
    //     var result;
    //     if (permissions.canViewJobCodesAdminUI()) {
    //         result = baseUrl + '/job-center-ui/' + hashbang + '/jobs/codes/shop';
    //     }
    //     return result;
    //
    // };

    /**
     * Get Shop Timecards Url
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getShopTimecardsUrl = function() {

        var result;

        if (permissions.canViewShopTimecardAdmin()) { // Timecard Admin Menu Page
            result = helper.getShopTimeCardsAdminUrl();
        } else if (permissions.canViewShopTimecardWorkstation()) { // Timecard Workstation Select User Page
            result = helper.getShopTimeCardsSelectUserUrl();
        }

        return result;

    };

    /**
     * Get The Shop Timecards Admin URL
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getShopTimeCardsAdminUrl = function () {

        var result;
        if (permissions.canViewShopTimecardAdmin()) {
            result = baseUrl + '/timecard-ui/' + hashbang + '/dashboard/admin';
        }
        return result;

    };

    /**
     * Get The Shop Timecards Select User URL
     *
     * @since 1.0.0
     * @return {String}
     */
    helper.getShopTimeCardsSelectUserUrl = function () {

        var result;
        if (permissions.canViewShopTimecardWorkstation()) {
            result = baseUrl + '/timecard-ui/' + hashbang + '/select/user';
        }
        return result;

    };

    /**
     * Get a subcategories listing URL
     *
     * @since 1.0.0
     * @param {String} index
     * @return {String}
     */
    helper.getSubCategoriesUrl = function(index) {

        var result;
        result = baseUrl + '/ordering-ui/' + hashbang + '/main/listings/' + index;
        return result;

    };

    /**
     * Get Terms & Conditions URL
     * @return {String}
     */
    helper.getTermsAndConditionsUrl = function() {
        return 'https://legal.cordance.co/buildcentrix';
    };

    /**
     * Get Timecards Url
     *
     * @since 1.14.0
     * @return {String}
     */
    helper.getTimecardsUrl = function() {

        var result;

        // If user can view Timecards UI
        if (permissions.canViewTimecardsUI()) {

            // Return Timecards Base Url
            result = baseUrl + '/timecard-ui/'

        }

        return result;

    };

    /**
     * Get Timecard Entries Report Url
     *
     * @since 2.54.0
     * @return {String}
     */
    helper.getTimecardEntriesReportUrl = function() {

        var result;

        // If user can view Timecards UI
        if (permissions.canViewTimecardEntriesReportUI()) {

            // Return Timecards Base Url
            result = baseUrl + '/timecard-ui/' + hashbang + '/reports/entries';

        }

        return result;

    };

    /**
     * Get Timecard Overview Report Url
     *
     * @since 2.54.0
     * @return {String}
     */
    helper.getTimecardOverviewReportUrl = function() {

        var result;

        // If user can view Timecards UI
        if (permissions.canViewTimecardOverviewReportUI()) {

            // Return Timecards Base Url
            result = baseUrl + '/timecard-ui/' + hashbang + '/reports/timecards';

        }

        return result;

    };

    /**
     * Get Tool Tracker Url
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getToolTrackerUrl = function () {

        var result;
        if (permissions.canViewInventoryAdminUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/orders';
        }
        return result;

    };

    /**
     * Get Tool Tracker Inventory Type URL
     *
     * @since 1.0.0
     * @param {String} subcategoryId
     * @returns {String}
     */
    helper.getToolTrackerInventoryTypeUrl = function (subcategoryId) {

        var result;
        if (permissions.canViewInventoryAdminUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/inventoryTypes/' + subcategoryId + '#top';
        }
        return result;

    };

    /**
     * Get Tool Tracker Inventory Type URL (from tracker-api)
     *
     * @since 1.1.0
     * @param {Number} inventoryTypeIndex
     * @returns {String}
     */
    helper.getToolTrackerInventoryTypeApiUrl = function (inventoryTypeIndex) {

        var result;
        var trackerApiUrl = helper.getApiUrl('tracker');

        result = trackerApiUrl + 'inventory/types/' + inventoryTypeIndex;

        return result;
    };

    /**
     * Get Tool Tracker Inventory Type URL
     *
     * @since 1.0.0
     * @param {String} subcategoryId
     * @returns {String}
     */
    helper.getToolTrackerInventoryTypeUrl = function (subcategoryId) {

        var result;
        if (permissions.canViewInventoryAdminUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/inventoryTypes/' + subcategoryId + '#top';
        }
        return result;

    };

    /**
     * Get Tool Tracker Orders URL
     *
     * @since 1.0.0
     * @param {String} orderId
     * @returns {String}
     */
    helper.getToolTrackerOrderUrl = function (orderId) {

        var result;
        if (permissions.canViewInventoryAdminUI()) {
            result = baseUrl + '/tracker-ui/' + hashbang + '/main/orders/requests/' + orderId + '#top';
        }
        return result;

    };

    /**
     * Get Default Landing Page URL
     * Users without a saved landing page option will be directed here by default
     *
     * @since 2.51.0
     * @returns {String} url
     */
    helper.getDefaultLandingPageUrl = function () {
        var result;
        if (permissions.canViewLandingPageUI()) {
            result = baseUrl + '/dashboard-ui-v2/welcome';
        }
        return result
    };

    /**
     * Get User Landing Page URL by Key
     *
     * @since 2.51.0
     * @param {String} key
     * @returns {String} url
     */
    helper.getUserLandingPageByKey = function (key) {

        var result;
        switch(key) {
            // 1: Assemblies
            case 'assembliesUi':
                result = helper.getAssembliesUrl();
                break;
            // 2: Order Admin
            case 'orderAdminUi':
                result = helper.getWorkOrdersUrl();
                break;
            // 3: Jobs Admin
            case 'jobCenterUi':
                result = helper.getJobAdminUrl();
                break;
            // 4: Production Calendar
            case 'productionCalendarUi':
                result = helper.getProductionCalendarUrl();
                break;
            // 5: Piping and Plumbing
            case 'productUi':
                result = helper.getProductUrl();
                break;
            // 6: Inventory Tracking
            case 'toolTrackerUi':
                result = helper.getToolTrackerUrl();
                break;
            // 7: Manufacturing Admin
            case 'manufacturingAdminUi':
                result = helper.getManufacturingAdminUrl();
                break;
            // 8: Dashboard
            case 'dashboardUi':
                result = helper.getDashboardUrl();
                break;
            // 9: Reimbursements
            case 'reimbursementUi':
                result = helper.getReimbursementsUrl();
                break;
            // 10: Duct and Fabrication
            case 'orderingUi':
                result = helper.getOrderingUrl();
                break;
            // 11: Shipping Calendar
            case 'shippingCalendarUi':
                result = helper.getShippingCalendarUrl();
                break;
            // 12: Timecards
            case 'timecardUi':
                result = helper.getTimecardsUrl();
                break;
            default:
                result = helper.getDefaultLandingPageUrl();
        }

        // Invalid permissions / Redirect empty results to default
        if (!result) {
            result = helper.getDefaultLandingPageUrl();
        }

        return result;

    };

    /**
     * Get Users Admin URL
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getUsersAdminUrl = function () {
        var result;
        if (permissions.canViewUsersAdminUI()) {
            result = baseUrl + '/organization-ui/users/list';
        }
        return result;
    };

    /**
     * Get Users URL
     *
     * @deprecated To standardize naming conventions. Use "getUsersAdminUrl"
     * @since 2.2.0
     * @returns {String}
     */
    helper.getUsersUrl = function () {
        var result;
        if (permissions.canViewUsersAdminUI()) {
            result = baseUrl + '/organization-ui/users/list';
        }
        return result;
    };

    /**
     * Get Users Manager URL
     *
     * @since 2.5.0
     * @param {String} id
     * @returns {String}
     */
    helper.getUsersManagerUrl = function (id) {
        var result;
        if (permissions.canViewUsersAdminUI()) {
            result = baseUrl + '/organization-ui/users/manage' + id ? ('/' + id) : '';
        }
        return result;
    };

    /**
     * Get User Groups Admin URL
     *
     * @since 2.54.0
     * @returns {String}
     */
    helper.getUserGroupsAdminUrl = function () {
        var result;
        if (permissions.canViewUserGroupsAdminUI()) {
            result = baseUrl + '/organization-ui/users/groups/list';
        }
        return result;
    };

    /**
     * Get User Groups URL
     *
     * @deprecated To standardize naming conventions. Use "getUserGroupsAdminUrl"
     * @since 2.21.0
     * @returns {String}
     */
    helper.getUserGroupsUrl = function () {
        return baseUrl + '/organization-ui/users/groups/list';
    };

    /**
     * Get Order Details URL
     *
     * @since 1.0.0
     * @param {String} orderIndex
     * @returns {String}
     */
    helper.getWorkOrderDetailsUrl = function (orderIndex) {

        return baseUrl + '/order-admin-ui/orders/manage/' + orderIndex;

    };

    /**
     * Get Work Order Shop Report Modern URL
     *
     * @since 1.0.0
     * @param {String} orderIndex
     * @returns {String}
     */
    helper.getWorkOrderShopReportModernUrl = function (orderIndex) {

        var result;
        if (permissions.canViewWorkOrderShopReportModern()) {
            result = baseUrl + '/order-admin-ui/orders/reports/shop/' + orderIndex;
        }
        return result;

    };

    /**
     * Get Work Order Billing Report URL
     *
     * @since 2.23.0
     * @param {String} orderIndex
     * @returns {String}
     */
    helper.getWorkOrderBillingReportUrl = function (orderIndex) {

        var result;
        if (permissions.canViewWorkOrderBillingReport()) {
            result = baseUrl + '/order-admin-ui/orders/reports/billing/' + orderIndex;
        }
        return result;

    };

    /**
     * Get Work Order Supply Only Report URL
     *
     * @since 2.23.0
     * @param {String} orderIndex
     * @returns {String}
     */
    helper.getWorkOrderSupplyOnlyReportUrl = function (orderIndex) {

        var result;
        if (permissions.canViewWorkOrderSupplyOnlyReport()) {
            result = baseUrl + '/order-admin-ui/orders/reports/supplyOnly/' + orderIndex;
        }
        return result;

    };

    /**
     * Get Work Orders (orders listing) URL
     *
     * @since 1.0.0
     * @returns {String}
     */
    helper.getWorkOrdersUrl = function () {

        var result;
        if (permissions.canViewWorkOrdersUI()) {
            result = baseUrl + '/order-admin-ui/orders/list/work';
        }
        return result;

    };

    /**
     * Get Order Fulfillment Groups Url
     *
     * @since 1.26.0
     * @returns {String}
     */
    helper.getOrderFulfillmentGroupsUrl = function () {

        var result;
        result = baseUrl + '/manufacturing-admin-ui' + helper.getInternalOrderFulfillmentGroupsUrl(false);

        return result;

    };

    /****************************************** Initialization ********************************************************/

    /**
     * Set Base Url
     *
     * @since 1.0.0
     * @param {Object} input
     */
    helper.setBaseUrl = function (input) {
        baseUrl = input.substr(-1) === '/' ? input.substr(0, input.length - 1) : input;
    };

    /**
     * Set Base API Url
     *
     * @since 1.0.0
     * @param {Object} input
     */
    helper.setBaseApiUrl = function (input) {
        baseApiUrl = input.substr(-1) === '/' ? input.substr(0, input.length - 1) : input;
    };

    /**
     * Set API Urls
     *
     * Use this method if a UI requires additional APIs.  The UIs were designed to only support one API URLs
     * set in the baseApiUrl.  With this method we can now set one or more API URLs.
     * Example usage: in ordering-ui wdOrdering.js::loadApplicationData() we call setApiUrls() to set the tracker API URL.
     *
     * @since 1.1.0
     * @param {Array} input A list of objects for the API.
     * E.g.  [
     *  { id:'tracker',
     *    url: 'http://localhost:6300/inventory/types'
     *  }
     * ]
     */
    helper.setApiUrls = function (input) {
        for (var i=0; i<input.length; i++) {
            var api = input[i];

            if (api.hasOwnProperty('id')) {
                apiUrls[api.id] = api.url;
            }
        }
    };

    /**
     * Set Constants
     *
     * @since 1.0.0
     * @param {String} input
     */
    helper.setConstants = function (input) {
        constants = input;
    };

    /**
     * Set Deployment Token
     *
     * @since 1.0.0
     * @param {String} input
     */
    helper.setDeploymentToken = function (input) {
        deploymentToken = input;
    };

    /**
     * Set Permissions
     *
     * @since 1.0.0
     * @param {String} input
     */
    helper.setPermissions = function (input) {
        permissions = input;
    };

    /***************************************** Private Functions ******************************************************/

    /**
     * Build Url Suitable for Classic UI
     *
     * @since 1.0.0
     * @returns {String}
     */
    function buildClassicUrlPrefix(baseUrl, deploymentToken) {
        return baseUrl + '/' + classicHost + '/' + deploymentToken;
    }

    /**
     * Get Hashbang
     *
     * @since 1.0.0
     * @param {Boolean} showHashBang
     * @returns {String}
     */
    function getHashBang(showHashBang) {
        return showHashBang ? hashbang : '';
    }

    // Return
    return helper;

};
globalThis.WebductResources = WebductResources;
// EOF